export default __webpack_public_path__ + "static/media/1200px-Amazon_Web_Services_Logo.5a36f71d.png";